module.exports = __webpack_public_path__ + "img/green_054.a64b6cbb.png";